/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadOnlyFuelCompanySerializer
 */
export interface ReadOnlyFuelCompanySerializer {
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCompanySerializer
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCompanySerializer
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCompanySerializer
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOnlyFuelCompanySerializer
     */
    logoUrl?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReadOnlyFuelCompanySerializer
     */
    fuelCard: number;
}

export function ReadOnlyFuelCompanySerializerFromJSON(json: any): ReadOnlyFuelCompanySerializer {
    return ReadOnlyFuelCompanySerializerFromJSONTyped(json, false);
}

export function ReadOnlyFuelCompanySerializerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadOnlyFuelCompanySerializer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'label': json['label'],
        'logoUrl': !exists(json, 'logo_url') ? undefined : json['logo_url'],
        'fuelCard': json['fuel_card'],
    };
}

export function ReadOnlyFuelCompanySerializerToJSON(value?: ReadOnlyFuelCompanySerializer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'label': value.label,
        'logo_url': value.logoUrl,
        'fuel_card': value.fuelCard,
    };
}


